import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CommonSharedModule } from 'src/app/shared/common/common-shared.module';
import { KendoModule } from 'src/app/shared/kendo/kendo.module';
import { OnboardingSharedModule } from 'src/app/shared/onboarding/onboarding-shared.module';
import { AnnualRevenueComponent } from './annual-revenue/annual-revenue.component';
import { ApplicationSummaryComponent } from './application-summary/application-summary.component';
import { BusinessDescriptionComponent } from './business-description/business-description.component';
import { BusinessIndustryComponent } from './business-industry/business-industry.component';
import { BusinessInvoiceComponent } from './business-invoice/business-invoice.component';
import { BusinessProfileRoutingModule } from './business-profile-routing.module';
import { BusinessTypeComponent } from './business-type/business-type.component';
import { CompanyAddressComponent } from './company-address/company-address.component';
import { CompanyWebsiteComponent } from './company-website/company-website.component';
import { ConfirmCompanySearchComponent } from './confirm-company-search/confirm-company-search.component';
import { ConfirmDetailsComponent } from './confirm-details/confirm-details.component';
import { CustomerTypeComponent } from './customer-type/customer-type.component';
import { DbaComponent } from './dba/dba.component';
import { EmployeeCountComponent } from './employee-count/employee-count.component';
import { StateOfOrgComponent } from './state-of-org/state-of-org.component';
import { SupportMethodComponent } from './support-method/support-method.component';
import { YearFoundedComponent } from './year-founded/year-founded.component';

const components = [
  BusinessIndustryComponent,
  BusinessTypeComponent,
  CustomerTypeComponent,
  StateOfOrgComponent,
  DbaComponent,
  CompanyAddressComponent,
  AnnualRevenueComponent,
  CompanyWebsiteComponent,
  YearFoundedComponent,
  EmployeeCountComponent,
  BusinessInvoiceComponent,
  SupportMethodComponent,
  ConfirmDetailsComponent,
  ConfirmCompanySearchComponent,
  BusinessDescriptionComponent,
  ApplicationSummaryComponent,
];

const modules = [
  CommonModule,
  BusinessProfileRoutingModule,
  CommonSharedModule,
  KendoModule,
  OnboardingSharedModule,
];

@NgModule({
  declarations: [...components],
  imports: [...modules],
  exports: [...components, ...modules],
})
export class BusinessProfileModule {}
